// extracted by mini-css-extract-plugin
module.exports = {"root":"NestedTabs_root__25wgf","nestedTabs":"NestedTabs_nestedTabs__nLuwV","tab":"NestedTabs_tab__3urEd","tabContent":"NestedTabs_tabContent__cWHip"};